<template>
  <div class="show-actions-container text-right ml-4">
    <slot></slot>
    <button class="show-action-btn mr-1" @click="$emit('clickOnEditBtn', itemId)" v-if="!deleteOnly">
      <pencil-icon size="18"/>
    </button>
    <button class="show-action-btn" @click="$emit('clickOnDeleteBtn', itemId)" v-if="!editOnly">
      <trash-icon size="18"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "CardActions",

  props: {
    itemId: {
      type: Number,
      required: true
    },
    editOnly: {
      type: Boolean,
      default: false
    },
    deleteOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

.show-actions-container {
  min-width: 80px;
}
.show-action-btn {
  background-color: var(--main-color);
  border: none;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 4px 8px;
}
.show-action-btn:hover {
  background-color: var(--main-color-hover);
}

</style>



// WEBPACK FOOTER //
// src/components/CardActions.vue